const isEqual = require("react-fast-compare")

export function equals(actual: any, expected: any): boolean {
    return isEqual(actual, expected)
}
